<template>

  <div class="ai-summary-root" id="summary-line" v-if="insights?.length">

    <section class="ai-summary-block" data-ai-block="management">
      <div class="ai-summary-kicker">Управленческие рекомендации на основе анализа отзывов за
        <div class="period"> {{ period }}</div>
        <button class="btn btn-sm" @click="setDate(period)">показать период</button>
      </div>
      <div class="ai-summary-header">
        <div>
          <h3>Где отзывы показывают потери для бизнеса</h3>
          <p>Крупные негативные сигналы связаны с процессами и направлениями, где бизнес может терять деньги или
            клиентов.</p>
          <p class="ai-summary-note">Доля показывает, в какой части негативных отзывов недели встречается этот
            проблемный сигнал. Один отзыв может содержать несколько проблем, поэтому доли по карточкам не суммируются до
            100%.</p>
        </div>
      </div>
      <div class="ai-summary-mini-grid">
        <article class="ai-summary-mini" v-for="insight in insights">
          <div class="ai-summary-mini__title">{{ insight.title }}</div>
          <div class="ai-summary-mini__metric">{{ insight.negative_reviews }} негативных отзывов ·
            {{ insight.negative_share }}% негатива недели
          </div>
        </article>
      </div>
      <button type="button" @click="close=!close" class="ai-summary-toggle">
        <template v-if="close">Развернуть</template>
        <template v-else>Свернуть</template>
      </button>
      <div class="ai-summary-expanded" :hidden="close">
        <article class="ai-summary-card" v-for="insight in insights">
          <h4>{{ insight.title }}</h4>
          <p class="ai-summary-card__problem">{{ insight.problem }}</p>
          <div class="ai-summary-card__cause"><strong>Гипотез{{ insight.cause_hypotheses.length > 1 ? 'ы' : 'а' }}
            причины:</strong>
            <template v-if="insight.cause_hypotheses.length >1">
              <ol>
                <li v-for="cause in insight.cause_hypotheses">{{ cause }}</li>
              </ol>
            </template>
            <template v-else>
              <p v-for="cause in insight.cause_hypotheses">{{ cause }}</p>
            </template>
          </div>
          <div class="ai-summary-card__metric">{{ insight.negative_reviews }} негативных отзывов ·
            {{ insight.negative_share }}% негатива недели
          </div>
          <div class="ai-summary-card__list" v-if="insight.hypotheses">
            <strong>Гипотезы по поручениям:</strong>
            <ol>
              <li v-for="item in insight.hypotheses">{{ item }}</li>
            </ol>
          </div>
          <div class="ai-summary-card__list">
            <strong>Какие данные могут помочь обнаружить причину проблемы:</strong>
            <ul>
              <li v-for="item in insight.data_to_collect">{{ item }}</li>
            </ul>
          </div>
          <router-link class="ai-summary-card__reviews" target="_blank"
                       @click="goToReview(insight.title, insight.review_ids)"
                       :to="{name: 'project_reviews'}">
            Показать {{ $pluralise(insight.review_ids.length, ['отзыв', 'отзыва', 'отзывов']) }}
          </router-link>

        </article>
      </div>
    </section>
  </div>


</template>

<script>

export default {
  name: 'AiSummary',
  data() {
    return {
      close: true
    }
  },
  computed: {},
  props: {
    insights: {
      type: Array,
      default: () => []
    },
    period: {
      type: String,
      default: ""
    },
    goToReview: {
      type: Function,
      default: () => {
      }
    }
  },
  methods: {
    setDate(period){
      let [start, end] = period.split('-')
      this.$store.dispatch('setFilterDates', {from: this.$moment(start, 'DD.MM').format('YYYY-MM-DD'), to: false})
      this.$store.dispatch('setFilterDates', {from: false, to: this.$moment(end, 'DD.MM').format('YYYY-MM-DD')})

    }
  }
}
</script>

<style lang="scss">

.ai-summary-root {
  display: block;
  width: 100%;
  min-width: 0;
  margin: 0 0 22px;
}

.ai-summary-block {
  display: block;
  width: 100%;
  box-sizing: border-box;
  margin: 20px 0 18px;
  padding: 16px 18px 18px;
  background: #fff;
  border: 1px solid #d9e2ef;
  border-left: 4px solid #2563eb;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, .04);
}

.ai-summary-kicker {
  margin-bottom: 8px;
  color: #2563eb;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: .08em;
  text-transform: uppercase;
  display: flex;
  align-content: center;
  align-items: center;
  gap: 5px;

  .btn {
    height: 27px;
    line-height: 5px;
    padding: 5px 8px;
    margin-left: 10px;
  }
  .period{
    color: #b0341a;
  }
}

.ai-summary-header {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 14px;
}

.ai-summary-header h3 {
  margin: 0 0 6px;
  font-size: 18px;
  line-height: 1.25;
  color: #0f172a;
}

.ai-summary-header p {
  max-width: 900px;
  margin: 0;
  color: #526173;
  font-size: 13px;
  line-height: 1.45;
}

.ai-summary-header .ai-summary-note {
  margin-top: 6px;
  color: #667085;
  font-size: 12px;
}

.ai-summary-header span {
  white-space: nowrap;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.ai-summary-mini-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 10px;
}

.ai-summary-mini,
.ai-summary-card {
  border: 1px solid #dbe5f1;
  border-radius: 7px;
  background: #f8fbff;
}

.ai-summary-mini {
  min-height: 102px;
  padding: 12px;
}

.ai-summary-mini__title {
  display: -webkit-box;
  min-height: 38px;
  overflow: hidden;
  color: #0f172a;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.35;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.ai-summary-mini__metric,
.ai-summary-card__metric {
  margin-top: 8px;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}

.ai-summary-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  padding: 8px 12px;
  border: 1px solid #c9d7ea;
  border-radius: 6px;
  background: #fff;
  color: #0f172a;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
}

.ai-summary-expanded {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.ai-summary-expanded[hidden] {
  display: none !important;
}

.ai-summary-card {
  padding: 14px;
  background: #fff;
}

.ai-summary-card h4 {
  margin: 0 0 8px;
  color: #0f172a;
  font-size: 14px;
  line-height: 1.35;
}

.ai-summary-card p {
  margin: 8px 0 0;
  color: #475569;
  font-size: 12px;
  line-height: 1.5;
}

.ai-summary-card__problem {
  color: #1f2937 !important;
  font-weight: 700;
}

.ai-summary-card__cause {
  margin-top: 10px;
  padding: 10px 12px;
  border-left: 3px solid #2563eb;
  border-radius: 6px;
  background: #f8fbff;
  color: #334155;
  font-size: 12px;
  line-height: 1.5;
}

.ai-summary-card__cause strong {
  display: block;
  margin-bottom: 4px;
  color: #0f172a;
}

.ai-summary-card__cause p {
  margin: 0;
}

.ai-summary-card__list {
  margin-top: 10px;
  color: #475569;
  font-size: 12px;
  line-height: 1.45;
}

.ai-summary-card__list strong {
  display: block;
  margin-bottom: 5px;
  color: #0f172a;
}

.ai-summary-card__list ol,
.ai-summary-card__list ul {
  margin: 0 0 0 18px;
  padding: 0;
}

.ai-summary-card__list li {
  margin: 4px 0;
}

.ai-summary-card__reviews {
  margin-top: 12px;
  padding: 7px 10px;
  border: 1px solid #d0d8e4;
  border-radius: 6px;
  background: #f8fafc;
  color: #0f172a;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
}

.ai-summary-empty {
  padding: 14px;
  border: 1px dashed #cbd5e1;
  border-radius: 7px;
  background: #f8fafc;
  color: #475569;
  font-size: 13px;
  line-height: 1.5;
}

@media (max-width: 720px) {
  .ai-summary-header {
    flex-direction: column;
  }
  .ai-summary-expanded {
    grid-template-columns: 1fr;
  }
}


</style>